// extracted by mini-css-extract-plugin
export var quillEditor = "_jp-1";
export var variable = "_jp-0";